"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableContainerOverrides = function (_a) {
    var palette = _a.palette, shape = _a.shape, spacing = _a.spacing;
    return ({
        root: {
            backgroundColor: palette.background.paper,
            borderRadius: shape.borderRadius,
            padding: spacing(0, 4, 4),
        },
    });
};
//# sourceMappingURL=MuiTableContainer.js.map